import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCss3Component } from './simple-icons-css3.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCss3Component ],
    exports:      [ SimpleIconsCss3Component ],
    bootstrap:    []
})
export class SimpleIconsCss3Module {}
